import { Team } from '@yandex-int/k-common/typings';
import React, { useState, useCallback, useEffect } from 'react';
import ym from 'react-yandex-metrika';

import { getDefaultGrade as getDefaultGradeUtil } from 'utils/get-default-subject-page-grade';

import Description from '../__description/subject-page__description';
import GradeTabs from '../__grade-tabs/subject-page__grade-tabs';
import { useCurrentGrade } from '../../../utils/use-current-grade';

interface Props {
    currentTeam: Team | null;
    subjectPages: Array<any>;
    subject: string;
    hasGradeDifference: boolean;
}

const SubjectPageInfo = (props: Props) => {
    const { subjectPages, subject, hasGradeDifference } = props;
    const currentTeamLevel = useCurrentGrade();
    const defaultGrade = currentTeamLevel || getDefaultGradeUtil(subjectPages);

    const [currentGrade, setCurrentGrade] = useState(defaultGrade);

    const handleClickTab = useCallback(
        (grade: number) => {
            setCurrentGrade(grade);

            ym('reachGoal', 'teacher_library_subject_page_grade_click', { grade, currentTeamLevel });
        },
        [currentTeamLevel]
    );

    useEffect(() => {
        setCurrentGrade(defaultGrade);
    }, [defaultGrade]);

    return (
        <>
            <GradeTabs
                currentGrade={currentGrade}
                onClickTab={handleClickTab}
                shouldShowGradeTabs={hasGradeDifference}
                subject={subject}
                subjectPages={subjectPages}
            />
            <Description currentGrade={currentGrade} subject={subject} subjectPages={subjectPages} />
        </>
    );
};

export default SubjectPageInfo;
